import { render, staticRenderFns } from "./envelope-document-select-modal.vue?vue&type=template&id=c543f620&scoped=true"
import script from "./envelope-document-select-modal.vue?vue&type=script&lang=js"
export * from "./envelope-document-select-modal.vue?vue&type=script&lang=js"
import style0 from "./envelope-document-select-modal.vue?vue&type=style&index=0&id=c543f620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c543f620",
  null
  
)

export default component.exports